/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putProjectsProjectidPreferencesUnitsUnitidPathProjectIdSchema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidPathUnitIdSchema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidStatus200Schema = z.object({
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
})

export const putProjectsProjectidPreferencesUnitsUnitidStatus400Schema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidStatus401Schema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidStatus404Schema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidStatus500Schema = z.string()

export const putProjectsProjectidPreferencesUnitsUnitidResponseSchema = putProjectsProjectidPreferencesUnitsUnitidStatus200Schema

export const putProjectsProjectidPreferencesUnitsUnitidErrorSchema = z.union([putProjectsProjectidPreferencesUnitsUnitidStatus400Schema, putProjectsProjectidPreferencesUnitsUnitidStatus401Schema, putProjectsProjectidPreferencesUnitsUnitidStatus404Schema, putProjectsProjectidPreferencesUnitsUnitidStatus500Schema])

export const putProjectsProjectidPreferencesUnitsUnitidBodySchema = z.object({
  type: z.enum(['area', 'density', 'diameter', 'differentialPressure', 'electricalPower', 'energy', 'flow', 'force', 'heatTransfer', 'kinematicViscosity', 'kvCvCoefficient', 'length', 'linearPressureDrop', 'mass', 'roughness', 'specificHeat', 'staticPressure', 'temperature', 'temperatureDifference', 'thermalConductivity', 'thermalPower', 'thickness', 'torque', 'velocity', 'volume', 'waterHardness']).describe('The type of the unit').meta({ examples: ['length'] }),
  value: z.string().describe('The preferred unit of the user for the given type').meta({ examples: ['_U_LENGTH_CM'] }),
}).optional()
